module.exports = __webpack_public_path__ + "static/media/bridge.bcc27a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/bridge.png
// module id = 2546
// module chunks = 0